// extracted by mini-css-extract-plugin
export default {"title":"Products_title__zygn4","description":"Products_description__ewwnY"};